$(document).ready(function () {
    const ajaxPathExtraCategory = '/action/extra-category';
    const ajaxPathExtraCategoryUpdateSortPriority = '/sort-priority';
    const ajaxPathExtraCategorySearchProducts = '/products/search';
    let ajaxLockActive = false;
    let debounceTimer;

    function updateSortPriority() {
        if (ajaxLockActive === true) {
            return;
        }

        ajaxLockActive = true;

        const extraCategoryIds = [];
        $('#extra_categories_list .extra_category_item', document).each(function (_, element) {
            extraCategoryIds.push($(element).attr('data-id'));
        });

        $.ajax({
            type: 'PATCH',
            url: `${ajaxPathExtraCategory}${ajaxPathExtraCategoryUpdateSortPriority}`,
            data: {
                extra_category_ids: extraCategoryIds
            }
        }).success(function (data) {
            $('#extra_category_wrapper #extra_categories_list_panel', document).notify(window.t('extraCategoryListSortPriority'), {
                position: "bottom center",
                className: 'success'
            });
        }).error(function (data) {
            $('#extra_category_wrapper #extra_categories_list_panel', document).notify(window.t('extraCategoryListSortPriorityError'), {
                position: "bottom center",
                className: 'error'
            });
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    }

    function initSortable() {
        if ($("#extra_category_wrapper #extra_categories_list", document).length && $("#extra_category_wrapper .extra_category_item", document).length) {
            new Sortable($("#extra_category_wrapper #extra_categories_list", document)[0], {
                axis: 'y',
                cursor: "move",
                tolerance: "pointer",
                onUpdate: function (e) {
                    updateSortPriority();
                }
            });
        }
    }

    function getProductItemRow(itemData) {
        return `<tr class="extra-category-product-row">
                        <td class="extra-category-product-name">${itemData.name}</td>
                        <td>${itemData.ean}</td>
                        <td>
                            <button class="btn extra_category_toggle_product_btn btn-danger"
                            data-product-id="${itemData.id}"
                            data-added-to-category="1">${window.t('extraCategoryFormProductsListButtonDelete')}</button>
                        </td>
                    </tr>`;
    }

    function collectFormData() {
        const data = {
            id: $('#extra_category_id', document).val(),
            name: $('#extra_category_name', document).val(),
            internal_name: $('#extra_category_internal_name', document).val(),
            buttons_type: $('#extra_category_buttons_type', document).val(),
            product_ids: []
        };

        $('#extra_category_products_list .extra_category_toggle_product_btn', document).each(function (_, element) {
            const productId = $(element).attr('data-product-id');
            const isAddedToCategory = $(element).attr('data-added-to-category');

            if (isAddedToCategory == 1) {
                if (productId > 0) {
                    data.product_ids.push({
                        product_id: productId,
                    });
                } else {
                    const name = $(element)
                        .parents('.extra-category-product-row')
                        .find('.extra-category-product-name')
                        .text();

                    data.product_ids.push({
                        product_id: 0,
                        name: name
                    });
                }
            }
        });

        return data;
    }

    initSortable();

    $(document).on('click', '#extra_categories_list_panel .extra_category_item', function () {
        if (ajaxLockActive) {
            return false;
        }

        const id = $(this).attr('data-id');

        ajaxLockActive = true;
        showPreloader();

        $.ajax({
            type: 'GET',
            url: `${ajaxPathExtraCategory}/${id}`,
            dataType: 'json'
        }).success(function (data) {
            $('#extra_category_form', document).html(data.html);
        }).error(function (data) {
            showErrors(window.t('extraCategoryGetError'), data, '#extra_category_wrapper');
        }).always(function () {
            hidePreloader();
            ajaxLockActive = false;
        });

        return false;
    });

    $(document).on('input', '#extra_category_wrapper #extra_category_products_list_search_input', function () {
        if (ajaxLockActive) {
            return false;
        }

        const searchInput = $(this);
        const extraCategoryId = $('#extra_category_id', document).val();
        const searchString = searchInput.val();

        const excludeProductIds = [];
        $('#extra_category_wrapper .extra_category_toggle_product_btn', document).each(function (_, element) {
            const productId = $(element).attr('data-product-id');
            excludeProductIds.push(productId);
        });

        clearTimeout(debounceTimer);

        debounceTimer = setTimeout(function () {
            $.ajax({
                type: 'POST',
                url: `${ajaxPathExtraCategory}/${extraCategoryId}${ajaxPathExtraCategorySearchProducts}`,
                data: {
                    search_string: searchString,
                    exclude_product_ids: excludeProductIds,
                },
                dataType: 'json'
            }).success(function (data) {
                $('#extra_category_wrapper #extra_category_products_list_search_result', document).html(data.html);
            }).error(function () {
                searchInput.notify(window.t('extraCategoryProductsSearchError'), {
                    position: "top",
                    className: 'error'
                });
            }).always(function () {
                ajaxLockActive = false;
            });
        }, 300);

        return false;
    });

    $(document).on('click', '#extra_category_wrapper #extra_category_products_list_search_clear', function () {
        $('#extra_category_products_list_search_input', document).val('');
        $('#extra_category_products_list_search_result', document).html('');

        return false;
    });

    $(document).on('click', '#extra_category_products_list_search_result .add-product', function () {
        const itemData = {
            id: $(this).attr('data-product-id'),
            name: $(this).attr('data-product-name'),
            ean: $(this).attr('data-ean')
        }

        $('#extra_category_products_list_empty', document).remove();

        const tbody = $('#extra_category_products_list table tbody', document);

        tbody.append(getProductItemRow(itemData));

        $(this).remove();

        return false;
    });

    $(document).on('click', '#extra_category_product_free_text_btn', function () {
        const freeText = $('#extra_category_product_free_text_input', document).val();

        if (freeText === '') {
            return;
        }

        const itemData = {
            id: 0,
            name: freeText,
            ean: ''
        }

        $('#extra_category_products_list_empty', document).remove();

        const tbody = $('#extra_category_products_list table tbody', document);

        tbody.append(getProductItemRow(itemData));

        return false;
    });

    $(document).on('click', '.extra_category_toggle_product_btn', function () {
        const isAddedToCategory = $(this).attr('data-added-to-category');

        const btn = $(this);

        if (isAddedToCategory == 0) {
            btn.text(window.t('extraCategoryFormProductsListButtonDelete'));
            btn.attr('data-added-to-category', 1);
            btn.removeClass('btn-primary').addClass('btn-danger');
        }

        if (isAddedToCategory == 1) {
            btn.text(window.t('extraCategoryFormProductsListButtonAdd'));
            btn.attr('data-added-to-category', 0);
            btn.removeClass('btn-danger').addClass('btn-primary');
        }

        return false;
    });

    $(document).on('click', '#extra_category_wrapper #extra_category_btn_create', function () {
        if (ajaxLockActive) {
            return false;
        }

        const formData = collectFormData();

        ajaxLockActive = true;
        showPreloader();

        $.ajax({
            type: 'POST',
            url: ajaxPathExtraCategory,
            data: formData
        }).success(function (data) {
            window.location.reload();
        }).error(function (data) {
            hidePreloader();
            showErrors(window.t('extraCategoryCreateError'), data, '#extra_category_wrapper');
        }).always(function () {
            ajaxLockActive = false;
        });

        return false;
    });


    $(document).on('click', '#extra_category_wrapper #extra_category_btn_update', function () {
        if (ajaxLockActive) {
            return false;
        }

        const formData = collectFormData();

        ajaxLockActive = true;
        showPreloader();

        $.ajax({
            type: 'POST',
            url: `${ajaxPathExtraCategory}/${formData['id']}`,
            data: formData
        }).success(function (data) {
            window.location.reload();
        }).error(function (data) {
            hidePreloader();
            showErrors(window.t('extraCategoryUpdateError'), data, '#extra_category_wrapper');
        }).always(function () {
            ajaxLockActive = false;
        });

        return false;
    });

    $(document).on('click', '#extra_category_wrapper #extra_category_btn_delete', function () {
        if (ajaxLockActive) {
            return false;
        }

        const extraCategoryName = $(this).attr('data-category-name');

        if (!confirm(`${window.t('extraCategoryDeleteConfirm')} "${extraCategoryName}"?`)) {
            return;
        }

        const extraCategoryId = $('#extra_category_wrapper #extra_category_id', document).val();

        ajaxLockActive = true;
        showPreloader();

        $.ajax({
            type: 'DELETE',
            url: `${ajaxPathExtraCategory}/${extraCategoryId}`
        }).success(function (data) {
            window.location.reload();
        }).error(function (data) {
            hidePreloader();
            showErrors(window.t('extraCategoryDeleteError'), data, '#extra_category_wrapper');
        }).always(function () {
            ajaxLockActive = false;
        });

        return false;
    });

    $(document).on('click', '#extra_category_wrapper #extra_categories_search_button', function () {
        if (ajaxLockActive) {
            return false;
        }

        const searchInput = $('#extra_category_wrapper #extra_categories_search_input', document);
        const searchString = searchInput.val();

        $.ajax({
            type: 'GET',
            url: ajaxPathExtraCategory,
            data: {
                search_string: searchString,
            },
            dataType: 'json'
        }).success(function (data) {
            $('#extra_category_wrapper #extra_categories_list', document).html(data.html);
        }).error(function () {
            searchInput.notify(window.t('extraCategorySearchError'), {
                position: "top",
                className: 'error'
            });
        }).always(function () {
            ajaxLockActive = false;
        });

        return false;
    });


    $(document).on('click', '#extra-products-frame .extra_category_panel_clear_selected_products', function (e) {
        e.preventDefault();

        const panel = $(this).closest('.panel');
        const inputs = panel.find('.extra_category_panel_input');
        inputs.each(function (_, element) {
            $(element).prop('checked', false);
            if ($(element).attr('type') === 'text') {
                $(element).val('0');
            }
        });

        return false;
    });


    // extra_category_product_free_text_btn
});
